'use client';

import Script from 'next/script';
import React, { useEffect } from 'react';

import { KinoheldShopConfig } from '@/app/[locale]/(embedded-layout)/_components/kinoheld-helper';

import { useIsMounted } from '@cineamo/ui/src/hooks/useIsMounted';

type KinoheldEframeSettings = {
    // Required
    cinemaPath: string;
    baseUrl: string;

    // Display Options
    layout?: 'movies' | string; // Default: 'movies'
    design?: string;
    lang?: string;
    movieId?: string;
    showId?: string;
    startDate?: string; // Format: YYYY-MM-DD

    // UI Control
    hideControls?: boolean;
    hideFilters?: boolean;
    hideTitle?: boolean;
    hideTrailer?: boolean;
    hideInfo?: boolean;
    hideEmptyPlaytimes?: boolean;
    hideFlags?: boolean;

    // Behavior
    enableReservations?: boolean;
    target?: '_self' | '_blank' | string;
    rb?: boolean;
    floatingCart?: boolean;

    // Scroll Control
    enableAutoScrolling?: boolean; // Default: true
    stickyHeader?: string; // CSS selector
    scrollOffset?: number; // Default: 0
};

type WindowWithKinoheld = Window &
    typeof globalThis & {
        kinoheldEframeSettings?: KinoheldEframeSettings;
    };

const KinoheldShop: React.FC<{ config: KinoheldShopConfig }> = ({ config }) => {
    const isMounted = useIsMounted();

    useEffect(() => {
        // Set Kinoheld configuration
        (window as WindowWithKinoheld).kinoheldEframeSettings = {
            cinemaPath: config.cinemaPath,
            baseUrl: config.baseUrl,
            rb: false,
            floatingCart: true
        };
    }, [config.cinemaPath, config.baseUrl]);

    if (!isMounted) {
        return null;
    }

    return (
        <div className="container mx-auto flex flex-1 flex-col">
            <div className="flex-1 flex flex-col">
                <div
                    id="kinoheld-eframe"
                    className="flex-1 [&_iframe]:outline-none [&_*]:outline-none"
                />
                <Script
                    src="https://www.kinoheld.de/dist/eframe/eframe.min.js"
                    strategy="afterInteractive"
                />
            </div>
        </div>
    );
};

export default KinoheldShop;
